//CG: partajarea cererilor de sursa FK intre randurile unei subliste randate ca ROWS. Fiecare rand e un
//formular propriu, deci fiecare combo isi cerea singur sursa: N randuri x M campuri FK = N*M cereri
//identice la deschiderea formularului. Nu e un cache de aplicatie - intrarile expira repede, cat sa
//acopere valul de la incarcarea stivei, ca sa nu servim liste invechite peste cateva minute.
export default class FieldSourceCache {
    constructor(ttlMs) {
        this.ttl = ttlMs != null ? ttlMs : FieldSourceCache.DEFAULT_TTL;
        this.entries = {};
    }

    //CG: request() se cheama doar cand nu avem ce imparti; primeste inapoi promisiunea lui $.ajax
    read(url, data, request) {
        let key = url + '|' + (data != null ? JSON.stringify(data) : '');
        let entry = this.entries[key];

        //CG: o cerere inca in zbor se imparte indiferent de vechime - randurile pornesc practic odata,
        //deci fara asta cache-ul ar fi mereu gol exact cand ne trebuie
        if (entry != null && (entry.pending || (Date.now() - entry.time) < this.ttl)) {
            return entry.promise.then(result => FieldSourceCache.copy(result));
        }

        //CG: fiecare tastare intr-un combo cu filtrare pe server e alta cheie, deci pe un formular tinut
        //deschis mult harta ar creste nelimitat; peste plafon aruncam tot, e mai ieftin decat un LRU
        if (Object.keys(this.entries).length >= FieldSourceCache.MAX_ENTRIES) {
            this.clear();
        }

        entry = { pending: true, time: Date.now(), promise: null };
        this.entries[key] = entry;

        entry.promise = Promise.resolve(request()).then(result => {
            entry.pending = false;
            entry.time = Date.now();
            return result;
        }).catch(err => {
            //CG: cererea picata nu se tine minte - urmatorul rand trebuie sa aiba voie sa reincerce
            if (this.entries[key] === entry) {
                delete this.entries[key];
            }
            throw err;
        });

        return entry.promise.then(result => FieldSourceCache.copy(result));
    }

    //CG: cand utilizatorul adauga o valoare noua in nomenclator (AllowAdd) listele tinute minte devin
    //vechi pe loc, deci se arunca tot - sunt oricum doar cateva intrari
    clear() {
        this.entries = {};
    }

    //CG: fiecare consumator primeste copia lui - Kendo isi impacheteaza si isi modifica elementele din
    //dataSource, deci un array partajat intre doua controale s-ar contamina intre randuri
    static copy(result) {
        try {
            return JSON.parse(JSON.stringify(result));
        } catch (e) {
            return result;
        }
    }
}

FieldSourceCache.DEFAULT_TTL = 60000;
FieldSourceCache.MAX_ENTRIES = 200;
